import React from "react";
import { ArrowUpRight } from "lucide-react";

import { useEnvironment } from "@/context/EnvironmentContext";

import "./DialogPopupProjectDocuments.css";

function DialogPopupProjectDocuments({ selectedProject }) {
  const { selectedEnvironment } = useEnvironment();

  const workspaceUrl = selectedEnvironment?.workspace_url;
  const projectDocumentsUrl = !workspaceUrl
    ? null
    : selectedProject?.id
    ? `${workspaceUrl}/app-0001/documents?projectId=${encodeURIComponent(selectedProject.id)}`
    : workspaceUrl;
  const isProjectDocumentsLinkDisabled = !projectDocumentsUrl;

  return (
    <div className="dialog-popup-project-documents-section">
      <label className="dialog-popup-project-documents-label">
        <span className="dialog-popup-project-documents-title">Upload Files in Project Documents</span>
        <span className="dialog-popup-project-documents-description">
          To use additional files for this section, upload them in the workspace documents page first, then return here
          and regenerate.
        </span>
      </label>
      <a
        href={projectDocumentsUrl || undefined}
        target={isProjectDocumentsLinkDisabled ? undefined : "_blank"}
        rel={isProjectDocumentsLinkDisabled ? undefined : "noreferrer"}
        aria-disabled={isProjectDocumentsLinkDisabled}
        className={`dialog-popup-project-documents-link ${
          isProjectDocumentsLinkDisabled ? "dialog-popup-project-documents-link-disabled" : ""
        }`}
        onClick={(event) => {
          if (isProjectDocumentsLinkDisabled) {
            event.preventDefault();
          }
        }}
      >
        <span>Open Project Documents</span>
        <ArrowUpRight className="dialog-popup-project-documents-link-icon" size={16} aria-hidden="true" />
      </a>
    </div>
  );
}

export default DialogPopupProjectDocuments;
